// extracted by mini-css-extract-plugin
module.exports = {"products":"WishList_products__20qkq","wishlistHead":"WishList_wishlistHead__3GGkn"};